import React from 'react';
import { Link } from 'react-router-dom';

function MarketingDemo() {
  return (
    <div className="marketing-demo">
      {/* Hero */}
      <section className="marketing-hero marketing-hero-short">
        <div className="marketing-hero-content">
          <h1 className="marketing-hero-title">Try DeedStack™ Free</h1>
          <p className="marketing-hero-subtitle">
            Start your 14-day free trial or explore our live demo to see DeedStack™ in action.
          </p>
        </div>
      </section>

      {/* Demo Credentials - Both Portals */}
      <section className="marketing-demo-options">
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: '1rem' }}>Try Our Live Demo</h2>
          <p className="section-subtitle" style={{ marginBottom: '2rem', textAlign: 'center' }}>
            Explore both the admin dashboard and customer portal with sample data
          </p>

          <div className="demo-options-grid">
            {/* Admin Dashboard Demo */}
            <div className="demo-option-card demo-card-primary">
              <div className="demo-card-icon">🖥️</div>
              <h2>Admin Dashboard Demo</h2>
              <p>
                Manage properties, loans, customers, and settings. See the full admin experience.
              </p>

              <div className="demo-credentials">
                <h4>Admin Login Credentials</h4>
                <div className="credential-row">
                  <span className="credential-label">URL:</span>
                  <code>demo.deedstack.com/admin</code>
                </div>
                <div className="credential-row">
                  <span className="credential-label">Email:</span>
                  <code>demo@deedstack.com</code>
                </div>
                <div className="credential-row">
                  <span className="credential-label">Password:</span>
                  <code>demodemo123</code>
                </div>
              </div>

              <div className="demo-includes">
                <h4>What You Can Do:</h4>
                <ul>
                  <li>Browse and manage properties</li>
                  <li>View customer loans and payments</li>
                  <li>Generate reports and analytics</li>
                  <li>Explore settings and branding</li>
                </ul>
              </div>

              <a
                href="https://demo.deedstack.com/admin/login"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-large"
              >
                Open Admin Dashboard
              </a>
            </div>

            {/* Customer Portal Demo */}
            <div className="demo-option-card demo-card-customer">
              <div className="demo-card-icon">👤</div>
              <h2>Customer Portal Demo</h2>
              <p>
                Experience what your buyers see. View loans, make payments, and access documents.
              </p>

              <div className="demo-credentials">
                <h4>Customer Login Credentials</h4>
                <div className="credential-row">
                  <span className="credential-label">URL:</span>
                  <code>demo.deedstack.com/login</code>
                </div>
                <div className="credential-row">
                  <span className="credential-label">Email:</span>
                  <code>john.smith@example.com</code>
                </div>
                <div className="credential-row">
                  <span className="credential-label">Password:</span>
                  <code>Demo123!</code>
                </div>
              </div>

              <div className="demo-includes">
                <h4>What Customers Can Do:</h4>
                <ul>
                  <li>View loan balance and schedule</li>
                  <li>Make payments online</li>
                  <li>See payment history</li>
                  <li>Download documents</li>
                </ul>
              </div>

              <a
                href="https://demo.deedstack.com/login"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-large"
              >
                Open Customer Portal
              </a>
            </div>
          </div>

          <p className="demo-note" style={{ textAlign: 'center', marginTop: '1.5rem' }}>
            This is sample data - feel free to explore! Sign up for a free trial to create your own account.
          </p>
        </div>
      </section>

      {/* Free Trial CTA */}
      <section className="marketing-demo-trial">
        <div className="container">
          <div className="trial-cta-card">
            <div className="trial-cta-content">
              <h2>Ready to Get Started?</h2>
              <p>Create your own account with a 14-day free trial. No credit card required.</p>
              <div className="trial-benefits-row">
                <span>✓ 3 active loans</span>
                <span>✓ 10 property listings</span>
                <span>✓ Customer portal</span>
                <span>✓ Full access</span>
              </div>
              <Link to="/signup" className="btn btn-secondary btn-large">
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll See */}
      <section className="marketing-demo-preview">
        <div className="container">
          <h2 className="section-title">What You'll See in the Demo</h2>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Admin Dashboard</h3>
              <p>Overview of your business with key metrics, quick actions, and navigation to all features.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h3>Property Management</h3>
              <p>Browse sample properties, see how listings are organized, and view property details.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Loan Tracking</h3>
              <p>View active loans, payment schedules, and amortization tables for sample customers.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Customer Portal</h3>
              <p>See the self-service experience your buyers will have when managing their loans.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Reports</h3>
              <p>Financial reports, tax summaries, and business analytics with sample data.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Settings</h3>
              <p>Explore branding options, business settings, and customization capabilities.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Questions */}
      <section className="marketing-demo-questions">
        <div className="container">
          <div className="questions-card">
            <h2>Have Questions?</h2>
            <p>
              Want a personalized walkthrough? Schedule a demo with our team and we'll show you
              exactly how DeedStack™ can work for your business.
            </p>
            <div className="questions-buttons">
              <Link to="/contact" className="btn btn-primary">
                Schedule a Demo
              </Link>
              <Link to="/signup" className="btn btn-secondary">
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MarketingDemo;
